import { AnyAction } from "redux";
import { GetProductReturns, UpdateProductReturns, UpdateProductReturnType, ResetMainDashboard, GetProductTypes, UpdateProductReturnById } from "../actions/actionTypes";
import { updateObject } from "../../services/utilService";
import update from 'react-addons-update';
import { Legend } from "../../shared/models/mainDashboardModel";

interface IColumn {
    id: string
    title: string
    cards: ICard[]
}

interface ICard {
    id: string
    title: string
    serialNo: string
    date: number
    productType: number
    type: []
}

interface IMainDashboardState {
    productTypes: [],
    productReturns: IColumn[],
    autoUpdate: boolean;
}

const initialState: IMainDashboardState = {
    productTypes: [],
    productReturns: [],
    autoUpdate: true
};

const updateProductReturnType = (state: any, action: any) => {
    const { columnIndex, cardIndex, value, oldValue } = action.payload;

    return update(state, {
        productReturns: {
            [columnIndex]: {
                items: {
                    [cardIndex]: {
                        [Legend[value]]: { $set: !oldValue }
                    }
                }
            }
        }
    })
}

const updateProductReturnById = (state: any, action: any) => {
    const { colPosition, cardIndex, card } = action.payload;
    const oldCard = state.productReturns[colPosition].items[cardIndex];
    return update(state, {
        productReturns: {
            [colPosition]: {
                items: {
                    [cardIndex]: {
                        $set: {
                            ...oldCard,
                            ...card
                        }
                    }
                }
            }
        }
    })
}

const resetToInitialState = (state: any) => {
    return updateObject(state, initialState);
}

const mainDashboardReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case GetProductTypes: return updateObject(state, { productTypes: action.payload });
        case GetProductReturns: return updateObject(state, { productReturns: action.payload });
        case UpdateProductReturns: return updateObject(state, { productReturns: action.payload });
        case UpdateProductReturnType: return updateProductReturnType(state, action);
        case UpdateProductReturnById: return updateProductReturnById(state, action);
        case ResetMainDashboard: return resetToInitialState(state);
        default: return state;
    }
}

export default mainDashboardReducer;